module.exports = __webpack_public_path__ + "img/campus-title.161cc8d5.png";